import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import type { RootState, AppDispatch } from './store'
import {NavigateFunction, useNavigate} from "react-router";

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppNavigate: () => NavigateFunction = useNavigate
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
